import { AutoCompleteOptionWithValue } from "../types/AutoCompleteOptionWithValue";
import React from "react";
import { LitigationUnion } from "../types/LitigationUnion";
import { translate } from "./Translations/translatorService.tsx";

export const courtPostalCodeAutoCompleteAdditionalProps = {
  freeSolo: true,
  isOptionEqualToValue: (option: AutoCompleteOptionWithValue, value: AutoCompleteOptionWithValue) =>
    option.value === value.value,
  extractNewValue: (newValue: AutoCompleteOptionWithValue) => (newValue ? newValue.value : null),
  getSelectedValue: (options: AutoCompleteOptionWithValue[], value: AutoCompleteOptionWithValue) =>
    options.find((opt: AutoCompleteOptionWithValue) => opt.value === value) || null,
  getOptionLabel: (option: AutoCompleteOptionWithValue) => {
    return option.value || "";
  },
  renderOption: (props: React.HTMLAttributes<HTMLLIElement>, option: AutoCompleteOptionWithValue) => {
    return option.value !== null ? (
      <li {...props} key={option.value}>
        {option.label}
      </li>
    ) : null;
  },
  options: ({ product }: { product: LitigationUnion }) => {
    let options = product.courtPostalCodeOptions.map((option) => ({
      label: `${option.value} (${translate(`${product.productClassName}.courtPostalCodeOptions.${option.type}`)})`,
      value: option.value,
    }));

    if (product.courtPostalCode && !options.some((option) => option.value === product.courtPostalCode)) {
      options.push({
        label: product.courtPostalCode,
        value: product.courtPostalCode,
      });
    }

    return options;
  },
};
